'use client';

import { useEffect, useState } from 'react';

import { off, onValue, ref } from 'firebase/database';

import { RealtimeDatabase } from 'services/firebase/client/rtdb';

type UseRealtimeBaseDataResult<T> = {
	data: T | null;
	loading: boolean;
	error: Error | null;
};

export function useRealtimeDatabase<T>(
	path: string,
): UseRealtimeBaseDataResult<T> {
	// States
	const [data, setData] = useState<T | null>(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState<Error | null>(null);

	// Effects
	useEffect(() => {
		const dbRef = ref(
			RealtimeDatabase,
			path.startsWith('/') ? path : '/' + path,
		);

		const unsubscribe = onValue(
			dbRef,
			(snapshot) => {
				const value = snapshot.val();
				setData(value);
				setLoading(false);
			},
			(error) => {
				setError(error);
				setLoading(false);
				console.error(error);
			},
		);

		return () => {
			off(dbRef);
			unsubscribe();
		};
	}, [path]);

	return { data, loading, error };
}
